function switchCurrency(value) {
    // console.log(`Switching Currency: ${value}`);
    setSavedCurrency(value);
}

function calculatePrices(){
    var currency = getSavedCurrency();
    switch (currency) {
        case "AED": {
            return {
                individualPrice: "300 AED",
                scriboPrice: "280 AED",
                pairPrice: "500 AED"
            }
        }
        case "RUB": {
            return {
                individualPrice: "6500 руб.",
                scriboPrice: "6000 руб.",
                pairPrice: "10000 руб."
            }
        }
        case "USD": {
            return {
                individualPrice: "85 USD",
                scriboPrice: "80 USD",
                pairPrice: "140 USD"
            }
        }
        case "EUR": {
            return {
                individualPrice: "70 EUR",
                scriboPrice: "65 EUR",
                pairPrice: "120 EUR"
            }
        }
        default: {
            return {
                individualPrice: "300 AED",
                scriboPrice: "280 AED",
                pairPrice: "500 AED"
            }
        }
    }
}

function getSavedCurrency(){
if (sessionStorage !== undefined) {
    var currency = sessionStorage.getItem('currency');
    // console.log(`Saved Currency: ${currency}`);
    return currency
}
return "AED"
}

function setSavedCurrency(value){
if (sessionStorage !== undefined) {
    sessionStorage.setItem('currency', value);
}
// console.log(`Saved Currency: ${value}`);
}

export { switchCurrency, getSavedCurrency, calculatePrices}
  